import { render, staticRenderFns } from "./WealthChartAction.vue?vue&type=template&id=4b9349cd&scoped=true"
import script from "./WealthChartAction.vue?vue&type=script&lang=ts"
export * from "./WealthChartAction.vue?vue&type=script&lang=ts"
import style0 from "./WealthChartAction.vue?vue&type=style&index=0&id=4b9349cd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9349cd",
  null
  
)

export default component.exports